import { Flex, Box, Text } from '@chakra-ui/react';
import { getColors } from './conversation-utils';

interface ThreadDividerProps {
  text: string;
  type?: 'time' | 'takeover' | 'ai-takeover';
}

export function ThreadDivider({ text, type = 'time' }: ThreadDividerProps) {
  const { lineColor, textColor, bgColor } = getColors(type);

  return (
    <Flex align="center" my={6}>
      <Box flex="1" h="1px" bg={lineColor} />
      <Text
        px={4}
        fontSize="sm"
        fontWeight="medium"
        color={textColor}
        bg={bgColor}
        py={type !== 'time' ? 1 : 0}
        borderRadius={type !== 'time' ? 'full' : undefined}
      >
        {text}
      </Text>
      <Box flex="1" h="1px" bg={lineColor} />
    </Flex>
  );
}
